// import React from "react";
import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import axios from "axios";

import Banner from "../../common/Banner";
import Hservice from "./Hservice";
import Hform from "./Hform";
import Hdemo from "./Hdemo";
import Htestimonials from "./Htestimonials";
import Faq from "./Faq";
import Hvideo from "./Hvideo";
import BookingProcess from "./BookingProcess";
import Coaching from "./Coaching";
import { Typewriter } from "react-simple-typewriter"


import "./marquee.css";

const Home = () => {
  const [teachers, setTeachers] = useState([]);
  const [price, setPrice] = useState(0); // State to track the selected price
    const [showHindi, setShowHindi] = useState(false);


  useEffect(() => {
    axios
      .get("https://topfaculty.co.in/api/teacher-list2.php")
      .then((response) => {
        console.log(response.data);
        setTeachers(response.data);
      })
      .catch((error) => {
        console.log("Error Fetching Data", error);
      });
  }, []);

  // Marquee functionality

  const marqueeRef = useRef(null);
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseOver = () => {
    setIsHovered(true);
    if (marqueeRef.current) {
      marqueeRef.current.stop(); // Stop the marquee when hovered
    }
  };

  const handleMouseOut = () => {
    setIsHovered(false);
    if (marqueeRef.current) {
      marqueeRef.current.start(); // Restart the marquee when mouse leaves
    }
  };

  return (
    <>
      <div className="home5">
        {" "}
        <Banner />
        <Hservice />
      </div>

      {/* About Us Start */}
      <div id="rs-about" className="rs-about sec-spacer">
        <div className="container">
          <div className=" mt-32  text-center">
             <h1 className="title text-center  mt-2 " style={{ fontWeight: "600" }}>
            📘  Welcome To {" "}
              {/* <strong style={{ color: "#f7b205" }}> TopFaculty</strong> */}
              <strong style={{ color: "#f7b205" }}>
                <Typewriter words={["  TopFaculty", " टॉप फैकल्टी"]} loop cursor cursorStyle='.' typeSpeed={300} deleteSpeed={50} delaySpeed={2000} />
              </strong>
            </h1>
          </div>


      <Hdemo />



          <div className="row">
            <div className="col-lg-4 col-md-12">
              <div className="about-img rs-animation-hover">
                <img
                  src="assetsfront/images/thub1.png"
                  style={{ opacity: "0.9" }}
                  alt="img02"
                />
                <a
                  className="popup-youtube rs-animation-fade"
                  href="https://media.viasacademy.com/Top%20faculty/top%20faculty.mp4"
                  title="Video Icon"
                ></a>

                <div className="overly-border" />
              </div>
            </div>

            <div className="col-lg-8 col-md-12">
              <div className="about-desc">
                <p style={{ textAlign: "justify" }}>
                  Top Faculty is a revolutionary online platform that connects
                  students with India’s best educators. Whether you’re a student
                  looking for quality learning, a teacher wanting to share
                  knowledge, or a coaching institute aiming to expand, Top
                  Faculty provides the perfect solution.
                </p>
                <p style={{ textAlign: "justify" }}>
                  Our platform offers flexible learning options, allowing
                  students to choose full courses or specific topics and learn
                  from the comfort of their homes. Teachers can reach a vast
                  student base, set their own schedules, and grow their careers.
                  Coaching institutes can onboard top tutors and offer
                  structured programs to a wider audience.
                </p>

     

 
                <p style={{ textAlign: "justify" }}>
                  With a focus on high-quality education, accessibility, and
                  seamless digital learning, Top Faculty is transforming the way
                  India learns. Join us today and be part of the future of
                  education!
                </p>
                  {!showHindi && (
          <button
            onClick={() => setShowHindi(true)}
            className="btn btn-primary mt-2"
          >
            Read More 
          </button>
        )}
              </div>
            </div>
            
            {showHindi && (
              <>
            <p style={{ textAlign: "justify" }}>
              {" "}
              <b>
                टॉप फैकल्टी एक क्रांतिकारी ऑनलाइन प्लेटफॉर्म है जो छात्रों को
                भारत के बेहतरीन शिक्षकों से जोड़ता है। चाहे आप एक छात्र हों जो
                गुणवत्तापूर्ण शिक्षा की तलाश में हैंए एक शिक्षक जो अपनी
                विशेषज्ञता साझा करना चाहते हैंए या एक कोचिंग संस्थान जो अपने
                पहुंच को बढ़ाना चाहता हैकृटॉप फैकल्टी आपके लिए एक उत्तम समाधान
                है। हमारा प्लेटफॉर्म लचीले सीखने के विकल्प प्रदान करता हैए जहां
                छात्र पूरे कोर्स या किसी विशेष विषय को चुनकर घर बैठे पढ़ सकते
                हैं। शिक्षक अपनी कक्षाएं निर्धारित कर सकते हैंए अधिक छात्रों तक
                पहुंच बना सकते हैं और अपने करियर को आगे बढ़ा सकते हैं। कोचिंग
                संस्थान अनुभवी शिक्षकों को जोड़कर अपने पाठ्यक्रमों को डिजिटल रूप
                से विस्तारित कर सकते हैं।
              </b>
            </p>
            <p style={{ textAlign: "justify" }}>
              {" "}
              <b>
                उच्च गुणवत्ता वाली शिक्षाए आसान पहुंच और डिजिटल लर्निंग को
                बढ़ावा देने के साथए टॉप फैकल्टी भारत में शिक्षा के नए आयाम
                स्थापित कर रहा है। आज ही जुड़ें और भविष्य की
                शिक्षा का हिस्सा बनें |
              </b>
            </p>
            </>
                 )}
          </div>
        </div>
      </div>

      <div id="rs-about" className="rs-about  ">
        <div className="container">
          <div className="row mb-pt-50">
            {/* Students */}
            <div className="col-md-4 mb-4">
              <div className="about-box">
                <h3>👨‍🎓 For Students</h3>
                <ul>
                  <li>
                    Top Faculties: Connect with highly qualified educators.
                  </li>
                  <li>Online Classes: Attend live academic sessions.</li>
                  <li>Recorded Videos: Watch pre-recorded lessons anytime.</li>
                  <li>Home Tuition: Book in-person tutoring sessions.</li>
                  <li>
                    Regional Language Classes: Learn in your own language.{" "}
                    <a
                      href="https://topfaculty.co.in"
                      target="_blank"
                      rel="noreferrer"
                    >
                      topfaculty.co.in
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            {/* Teachers */}
            <div className="col-md-4 mb-4">
              <div className="about-box">
                <h3>👩‍🏫 For Teachers</h3>
                <ul>
                  <li>Profile Creation: Show your expertise and experience.</li>
                  <li>
                    Student Connections: Reach students who need your help.
                  </li>
                  <li>
                    Flexible Teaching Modes: Teach online, offline, or hybrid.
                  </li>
                  <li>
                    Subject Specialization: Target UPSC, IAS, TGT, PRT, etc.
                  </li>
                </ul>
              </div>
            </div>

            {/* Coaching Centers */}
            <div className="col-md-4 mb-4">
              <div className="about-box">
                <h3>🏫 For Coaching Centers</h3>
                <ul>
                  <li>Faculty Recruitment: Hire experienced top educators.</li>
                  <li>
                    Institutional Growth: Enhance your teaching quality.{" "}
                    <a
                      href="https://topfaculty.co.in"
                      target="_blank"
                      rel="noreferrer"
                    >
                      topfaculty.co.in
                    </a>
                  </li>
                  <li>Course Expansion: Add more subjects and courses.</li>
                </ul>
                <p>
                  <strong>Note:</strong> Coaching centers can register for free
                  to access these benefits.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* About Us End */}

      {/* marquee */}
      <div id="rs-about" className="rs-about  ">
        <div className="container">
          <h2>📚 Featured Teachers</h2>
          <div className="marquee-container">
            <marquee
              ref={marqueeRef}
              behavior="scroll"
              direction="left"
              scrollamount={10}
              onMouseOver={handleMouseOver}
              onMouseOut={handleMouseOut}
            >
              <div className="marquee-line">
                {/* Card 1 */}

                {teachers.map((teacher, index) => {
                  return (
                    <div className="smart-card">
                      <div className="left-border"></div>
                      <img
                        src={
                          teacher.TeacherProfile
                            ? teacher.TeacherProfile
                            : "https://i.pinimg.com/736x/5f/40/6a/5f406ab25e8942cbe0da6485afd26b71.jpg"
                        }
                        alt=""
                      />
                      <div className="info">
                        <div className="name"> {teacher.TeacherName}</div>
                        <div className="subject">{teacher.TeacherState}</div>
                        <div className="location">
                          <Link
                            to={`/teacher/${teacher.TeacherId}/${teacher.TeacherName}`}
                            state={{ scrollToSection: true }}
                            style={{ color: "white" }}
                          >
                            VIEW
                          </Link>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </marquee>
          </div>
        </div>
      </div>
      {/* end marquee */}

      <Hform />
      <BookingProcess />
      <Hvideo />
      {/* <Hdemo /> */}
      <Htestimonials />
      <Coaching />
     
      <Faq />
     
    </>
  );
};

export default Home;
